const NOISE_ERROR_PATTERNS: readonly string[] = [
  'Failed to play notification sound: NotAllowedError',
];

interface RumEventLike {
  type?: string;
  error?: { message?: string; source?: string } | null;
}

// Backstop for cached pre-fix bundles that still console.error autoplay rejections;
// only console-sourced errors qualify so identical text from other sources is kept.
export function isNoiseRumErrorEvent(event: RumEventLike | null | undefined): boolean {
  if (event?.type !== 'error') return false;
  if (event.error?.source !== 'console') return false;
  const message = event.error?.message;
  if (typeof message !== 'string') return false;
  return NOISE_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
}

// beforeSend: return true to keep, false to discard; fail open so a throw here can never kill error collection.
export function dropNoiseRumEvents(event: RumEventLike | null | undefined): boolean {
  try {
    return !isNoiseRumErrorEvent(event);
  } catch {
    return true;
  }
}
